export default [
  { value: 2, text: 'form.field.salutation.option1' },
  { value: 3, text: 'form.field.salutation.option2' }
]